// utils
import { paramCase } from 'src/utils/change-case';
import { _id, _postTitles } from 'src/_mock/assets';

// ----------------------------------------------------------------------

const MOCK_ID = _id[1];

const MOCK_TITLE = _postTitles[2];

const ROOTS = {
  AUTH: '/auth/jwt',
  DASHBOARD: '/dashboard',
};

// ----------------------------------------------------------------------

export const paths = {
  comingSoon: '/coming-soon',
  page403: '/403',
  page404: '/404',
  page500: '/500',
  components: '/components',
  product: {
    root: `/product`,
    checkout: `/product/checkout`,
    details: (id) => `/product/${id}`,
    demo: {
      details: `/product/${MOCK_ID}`,
    },
  },
  post: {
    root: `/post`,
    details: (title) => `/post/${paramCase(title)}`,
    demo: {
      details: `/post/${paramCase(MOCK_TITLE)}`,
    },
  },
  // AUTH
  auth: {
    login: `${ROOTS.AUTH}/login`,
    changePassword: `${ROOTS.AUTH}/change-password`,
  },

  // DASHBOARD
  dashboard: {
    root: ROOTS.DASHBOARD,
    onboarding: `${ROOTS.DASHBOARD}/onboarding`,
    mail: `${ROOTS.DASHBOARD}/mail`,
    chat: `/chat/chat`,
    blank: `${ROOTS.DASHBOARD}/blank`,
    kanban: `${ROOTS.DASHBOARD}/kanban`,
    calendar: `${ROOTS.DASHBOARD}/calendar`,
    fileManager: `${ROOTS.DASHBOARD}/file-manager`,
    permission: `${ROOTS.DASHBOARD}/permission`,
    general: {
      app: `${ROOTS.DASHBOARD}/app`,
      ecommerce: `${ROOTS.DASHBOARD}/ecommerce`,
      analytics: `${ROOTS.DASHBOARD}/analytics`,
      banking: `${ROOTS.DASHBOARD}/banking`,
      booking: `${ROOTS.DASHBOARD}/booking`,
      file: `${ROOTS.DASHBOARD}/file`,
    },
    user: {
      root: `${ROOTS.DASHBOARD}/user`,
      new: `${ROOTS.DASHBOARD}/user/new`,
      list: `${ROOTS.DASHBOARD}/user/list`,
      cards: `${ROOTS.DASHBOARD}/user/cards`,
      profile: `${ROOTS.DASHBOARD}/user/profile`,
      account: `${ROOTS.DASHBOARD}/user/account`,
      edit: (id) => `${ROOTS.DASHBOARD}/user/${id}/edit`,
      demo: {
        edit: `${ROOTS.DASHBOARD}/user/${MOCK_ID}/edit`,
      },
    },
    appUser: {
      root: `${ROOTS.DASHBOARD}/app-users`,
      list: `${ROOTS.DASHBOARD}/app-users/list`,
    },
    adminUser: {
      root: `${ROOTS.DASHBOARD}/admin-users`,
    },
    users: {
      root: `${ROOTS.DASHBOARD}/users`,
    },
    projects: {
      root: `${ROOTS.DASHBOARD}/projects`,
    },
    projectAssign: {
      root: `${ROOTS.DASHBOARD}/project_management/project-assign`,
    },
    dataCollection: {
      root: `/project_management/data_collection`,
      forms: `/project_management/data_collection/forms`,
      createForm: `/project_management/data_collection/forms/create`,
      editForm: (id) => `/project_management/data_collection/forms/${id}/edit`,
      formData: (id) => `/project_management/data_collection/forms/${id}/data`,
      formSubmit: (id) => `/project_management/data_collection/forms/${id}/submit`,
      formAnalytics: (id) => `/project_management/data_collection/forms/${id}/analytics`,
    },
    organization: {
      root: `${ROOTS.DASHBOARD}/organizations`,
    },
    knots: {
      root: `${ROOTS.DASHBOARD}/knots-categories`,
    },
    country: {
      root: `${ROOTS.DASHBOARD}/country`,
    },
    reportReason: {
      root: `${ROOTS.DASHBOARD}/report-reasons`,
    },
    reports: {
      root: `${ROOTS.DASHBOARD}/reports`,
      monthly: `${ROOTS.DASHBOARD}/reports/monthly-attendance`,
    },
    setting: {
      root: `${ROOTS.DASHBOARD}/site-settings`,
    },
    moduleMaster: {
      root: `${ROOTS.DASHBOARD}/module-master`,
    },
    menuMaster: {
      root: `${ROOTS.DASHBOARD}/menu-master`,
    },
    festival: {
      root: `${ROOTS.DASHBOARD}/festival`,
    },
    submenuMaster: {
      root: `${ROOTS.DASHBOARD}/submenu-master`,
    },
    jurisdiction: {
      root: `${ROOTS.DASHBOARD}/jurisdiction`,
      country: `${ROOTS.DASHBOARD}/jurisdiction/country`,
      state: `${ROOTS.DASHBOARD}/jurisdiction/state`,
      city: `${ROOTS.DASHBOARD}/jurisdiction/cities`,
      block: `${ROOTS.DASHBOARD}/jurisdiction/blocks`,
      locality: `${ROOTS.DASHBOARD}/jurisdiction/localities`,
      holidays: `${ROOTS.DASHBOARD}/jurisdiction/holidays`,
    },
    product: {
      root: `${ROOTS.DASHBOARD}/product`,
      new: `${ROOTS.DASHBOARD}/product/new`,
      details: (id) => `${ROOTS.DASHBOARD}/product/${id}`,
      edit: (id) => `${ROOTS.DASHBOARD}/product/${id}/edit`,
      demo: {
        details: `${ROOTS.DASHBOARD}/product/${MOCK_ID}`,
        edit: `${ROOTS.DASHBOARD}/product/${MOCK_ID}/edit`,
      },
    },
    invoice: {
      root: `${ROOTS.DASHBOARD}/invoice`,
      new: `${ROOTS.DASHBOARD}/invoice/new`,
      details: (id) => `${ROOTS.DASHBOARD}/invoice/${id}`,
      edit: (id) => `${ROOTS.DASHBOARD}/invoice/${id}/edit`,
      demo: {
        details: `${ROOTS.DASHBOARD}/invoice/${MOCK_ID}`,
        edit: `${ROOTS.DASHBOARD}/invoice/${MOCK_ID}/edit`,
      },
    },
    post: {
      root: `${ROOTS.DASHBOARD}/post`,
      new: `${ROOTS.DASHBOARD}/post/new`,
      details: (title) => `${ROOTS.DASHBOARD}/post/${paramCase(title)}`,
      edit: (title) => `${ROOTS.DASHBOARD}/post/${paramCase(title)}/edit`,
      demo: {
        details: `${ROOTS.DASHBOARD}/post/${paramCase(MOCK_TITLE)}`,
        edit: `${ROOTS.DASHBOARD}/post/${paramCase(MOCK_TITLE)}/edit`,
      },
    },
    order: {
      root: `${ROOTS.DASHBOARD}/order`,
      details: (id) => `${ROOTS.DASHBOARD}/order/${id}`,
      demo: {
        details: `${ROOTS.DASHBOARD}/order/${MOCK_ID}`,
      },
    },
    job: {
      root: `${ROOTS.DASHBOARD}/job`,
      new: `${ROOTS.DASHBOARD}/job/new`,
      details: (id) => `${ROOTS.DASHBOARD}/job/${id}`,
      edit: (id) => `${ROOTS.DASHBOARD}/job/${id}/edit`,
      demo: {
        details: `${ROOTS.DASHBOARD}/job/${MOCK_ID}`,
        edit: `${ROOTS.DASHBOARD}/job/${MOCK_ID}/edit`,
      },
    },
    tour: {
      root: `${ROOTS.DASHBOARD}/tour`,
      new: `${ROOTS.DASHBOARD}/tour/new`,
      details: (id) => `${ROOTS.DASHBOARD}/tour/${id}`,
      edit: (id) => `${ROOTS.DASHBOARD}/tour/${id}/edit`,
      demo: {
        details: `${ROOTS.DASHBOARD}/tour/${MOCK_ID}`,
        edit: `${ROOTS.DASHBOARD}/tour/${MOCK_ID}/edit`,
      },
    },
    designationMaster: {
      root: `/hrm_management/user_management/designation`,
    },
    departmentMaster: {
      root: `/hrm_management/user_management/department`,
    },
    kraMaster: {
      root: `/task_management/kra_master`,
    },
    myTasks: {
      root: `/task_management/my_tasks`,
    },
    userGroup: {
      root: `/hrm_management/user_management/user_groups`,
    },
    staffMigrations: {
      root: `/hrm_management/user_management/staff_migrations`,
    },
    reportingHierarchy: {
      root: `/hrm_management/user_management/reporting_hierarchy`,
    },
    userRights: {
      root: `/hrm_management/user_management/user_rights`,
    },
    holiday: {
      root: `/hrm_management/user_management/holiday`,
    },
    holiday_managment: {
      root: `/hrm_management/holiday_managment`,
    },
    holiday_management: {
      root: `/hrm_management/holiday_management`,
    },
    attendance: {
      root: `/hrm_management/attendance`,
      forgetPunch: `/hrm_management/forget_punch`,
      approval: `${ROOTS.DASHBOARD}/hrm_management/user_management/attendance_approval`,
      forgetPunchApproval: `${ROOTS.DASHBOARD}/hrm_management/user_management/forget_punch_approval`,
    },
    unifiedCalendar: {
      root: `/hrm_management/calendar`,
    },
    planner: {
      root: `/hrm_management/planner`,
    },
    geoFencing: {
      root: `/hrm_management/geo_fencing`,
    },
    announcement: {
      root: `/hrm_management/announcement`,
    },
    leave: {
      root: `/leave_mangement/leave_applications`,
      approval: `/leave_mangement/leave_approvals`,
      balances: `/leave_mangement/leave_balances`,
    },
    resignation: {
      root: `/hrm_management/resignation`,
      approval: `/hrm_management/user_management/resignation_approval`,
    },
    expense: {
      root: `/expense/manage_expense`,
      category: `/expense/expense_category`,
      approval: `/expense/expense_approvals`,
    },
    super_admin: {
      templateRequests: `${ROOTS.DASHBOARD}/super_admin/template_requests`,
    },
    storage: {
      root: `${ROOTS.DASHBOARD}/storage`,
    },
    drive: {
      root: `${ROOTS.DASHBOARD}/drive`,
    },
    travelManagement: {
      root: `/travel_management`,
      vehicleTypes: `/travel_management/vehicle_types`,
      vehicleMileage: `/travel_management/vehical_milege`,
    },
    customDashboard: {
      root: `${ROOTS.DASHBOARD}/analytics-dashboard`,
      create: `${ROOTS.DASHBOARD}/analytics-dashboard/create`,
      edit: (id) => `${ROOTS.DASHBOARD}/analytics-dashboard/${id}/edit`,
      view: (id) => `${ROOTS.DASHBOARD}/analytics-dashboard/${id}`,
    },
    websiteBuilder: {
      root: `${ROOTS.DASHBOARD}/website-builder`,
      create: `${ROOTS.DASHBOARD}/website-builder/create`,
      edit: (id) => `${ROOTS.DASHBOARD}/website-builder/${id}/edit`,
      analytics: (id) => `${ROOTS.DASHBOARD}/website-builder/${id}/analytics`,
    },
    fieldStudio: {
      root: `${ROOTS.DASHBOARD}/fieldstudio/document_creator`,
      create: `${ROOTS.DASHBOARD}/fieldstudio/document_creator/create`,
      edit: (id) => `${ROOTS.DASHBOARD}/fieldstudio/document_creator/${id}/edit`,
      templates: `${ROOTS.DASHBOARD}/fieldstudio/document_creator/templates`,
      gallery: `${ROOTS.DASHBOARD}/fieldstudio/templates`,
      editor: (templateId) => `${ROOTS.DASHBOARD}/fieldstudio/editor/${templateId}`,
    },
    kiosk: {
      root: `${ROOTS.DASHBOARD}/kiosk/list`,
    },
    hiring: {
      root: `/hiring_management/job_openings`,
      jobs: `/hiring_management/job_openings`,
      applications: `/hiring_management/applications_hiring`,
      pipeline: `/hiring_management/pipeline`,
      interviews: `/hiring_management/interviews`,
      settings: `/hiring_management/hiring_settings`,
      analytics: `/hiring_management/analytics`,
      talentPool: `/hiring_management/talent_pool`,
      referrals: `/hiring_management/referrals`,
    },
  },
  // PUBLIC CAREERS PORTAL (no login needed)
  careers: {
    listing: (slug) => `/careers/${slug}`,
    apply: (slug, jobId) => `/careers/${slug}/apply/${jobId}`,
  },
};
